import { Controller } from "@hotwired/stimulus"

// The capture wizard's half of the floor-plan picker (TASK-177.3, decision-41).
//
// The QTag step pins the ASSET, and on the fresh-tag branch that asset does not
// exist yet — there is no id to POST against, and creating one before the
// engineer submits would leave an orphan ProductInstance behind every abandoned
// draft. So this variant of the picker never writes.
//
// It reads the three coordinates the shared floorplan-viewer controller has
// been maintaining in the hidden fields, hands them to the wizard as an event,
// and closes the modal. The pin itself is created at submit, against the
// instance the submit creates, inside the submission's own transaction.
//
// Bound to the form's `submit`, so the button and Enter take the same path.
export default class extends Controller {
  static targets = ["x", "y", "page"]

  capture(event) {
    event.preventDefault()

    const x = parseFloat(this.xTarget.value)
    const y = parseFloat(this.yTarget.value)
    const page = parseInt(this.pageTarget.value, 10)

    // A picker the engineer opened and never dropped a pin on closes with
    // nothing said — silently, because "you did not place a pin" is not news
    // to the person who did not place one.
    if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(page)) {
      window.dispatchEvent(new CustomEvent("modal:close-requested"))
      return
    }

    window.dispatchEvent(new CustomEvent("floorplan-pin:captured", {
      detail: { page_number: page, x_percent: x, y_percent: y }
    }))
    window.dispatchEvent(new CustomEvent("modal:close-requested"))
  }
}
